import React, { useState } from "react";
import { Button, FormFieldSet, PageTitle } from "../../../components";
import { jobBoardsOptions } from "../../../assets/data/jobBoardsEnumData";
import { useDispatch } from "react-redux";
import { getCareerBuilderApplicantsDataStart } from "../../../redux/slices/internalDbES/internalDbESlice";

// const filterFields = [
//   "Work Status",
//   "Job Categories",
//   "Relocation Filter",
//   "Search Radius in Miles",
//   "Freshness in Days",
//   "Employment Type",
//   "Minimum Travel Requirement",
//   "Minimum Degree",
//   "Compensation Type",
//   "Minimum Salary",
//   "Maximum Salary",
//   "Exclude Resumes with No Salary",
//   "Language Spoken",
//   "Currently Employed",
//   "Management Experience",
//   "Minimum Employees Managed",
//   "Maximum Commute",
//   "Security Clearance",
//   "Exclude VR Resumes",
//   "Militery Experience",
//   "Search Radius in Kilometers",
//   "Apply Last Activity",
//   "Search With Most Recent Job Title",
//   "Search With Most Recent Company",
//   "NicheInclusion",
//   "Lemmatize",
// ];

const CareerBuilderFiltersModal = ({ query, updateQuery, setPage }) => {
  const [filters, setFilters] = useState(() => {
  const initialQuery = query?.payload?.query || {};
  return { ...initialQuery };
});

  const dispatch = useDispatch();
  const handleChange = (field, value, isMulti) => {
    setFilters((prev) => ({
      ...prev,
      [field]: isMulti
        ? Array.isArray(value)
          ? Array.from(new Set(value))
          : []
        : value,
    }));
  };

  const formatMultiSelect = (value) => {
    return Array.isArray(value) ? value.join(",") : value || "";
  };

  const parseMultiSelect = (value) => {
    if (!value) return [];
    return typeof value === "string" ? value.split(",") : value;
  };

  const handleUpdatedQuerySearch = () => {

    const updatedQuery = {
      ...query,
      payload: {
        ...query?.payload,
        page: 1,
        query: { ...query?.payload?.query, ...filters, WorkStatus: formatMultiSelect(filters.WorkStatus), },
      },
    };
    updateQuery(updatedQuery);
    dispatch(
      getCareerBuilderApplicantsDataStart({
        ...updatedQuery,
        onSuccess: () => {if (setPage) setPage(1);},
      })
    );
  };

  return (
    <div className="w-full overflow-y-auto pr-2">
      <PageTitle title={"Filter Result"} tag="h5" />
      <div className="grid grid-cols-1  gap-5 mt-2 ">
        {jobBoardsOptions.map((filter, idx) => {
          const isMulti = filter.options && filter.options.length > 0;
          const alias =
            filter.alias || filter.title.replace(/\s+/g, "_").toLowerCase();
          const fieldValue = filters[alias] || (isMulti ? [] : "");
          return (
            <FormFieldSet
              key={idx}
              type={filter?.type ? filter?.type : "text"}
              title={filter.title}
              placeholder={filter.placeholder}  
              showSearch
              showSelectAll={isMulti}
              shadow
              options={filter.options || []}
              onChange={(value) => {
                // console.log(value)
                handleChange(filter.alias, value, filter?.type==="multiSelect"?true:false);
              }}
              value={fieldValue}
            />
          );
        })}
      </div>

      {/* Fixed bottom Apply button */}
      <div className="sticky bottom-0 bg-white pt-4 pb-2 border-t border-gray-200 grid grid-cols-1">
        <Button title="Apply" onClick={handleUpdatedQuerySearch} />
      </div>
    </div>
  );
};

export default CareerBuilderFiltersModal;
